<template>
  <div class="bg-neutral-100 pt-10 pb-[4.25rem] lg:pb-[6.75rem] px-4 lg:px-0">
    <atoms-card
      shadow="lg"
      size="default"
      class="py-6 px-4 md:p-10 md:pb-12 rounded-2.5xl max-w-wrapper-md mx-auto"
    >
      <atoms-headline
        tag="h1"
        class="lg:text-3.5xl text-2xl font-bold md:py-3 mb-6"
      >
        <slot name="title"></slot>
      </atoms-headline>

      <div
        class="
          text-base lg:text-lg
          [&>p]:mb-6 [&>p:last-child]:mb-0
          [&>h3]:mb-4 [&>h3]:font-bold [&>h3]:text-xl [&>h3]:md:text-2xl
          [&>h2]:mb-4 [&>h2]:font-bold [&>h2]:text-xl [&>h2]:md:text-2xl
          [&>ul]:list-disc [&>ul]:ml-12
          [&_ol]:list-decimal [&_ol]:ml-12
          [&_a]:underline [&_a]:font-bold
        "
      >
        <slot name="content"></slot>
      </div>
    </atoms-card>
  </div>
</template>

<script setup>
defineOptions({
  name: 'LayoutSimpleCard'
})
</script>
